import React from "react";
import { Button } from "@telia/teddy";
import { connect, useDispatch } from "react-redux";
import { RootState } from "../../../../../../models";
import { Voucher } from "../../../../../../models/state/voucher";
import { getFormattedPrice } from "../../../../../../shared/priceFormatter";
import * as LOADING_SELECTORS from "../../../../loading/state/selectors";
import { removeVoucherCode } from "../../../state/actions";
import { VOUCHER_REMOVE } from "../../../state/actionTypes";
import { getValidatedVouchers } from "../../../state/selectors";
import TEXT from "../../../text-consts";
import { anonymizeVoucherCode } from "../../../utils";
import "./VoucherTable.less";

interface VoucherTableProps {
    isRemovingVoucher: boolean;
    vouchers: Voucher[];
}

const VoucherTable: React.FC<VoucherTableProps> = ({ vouchers, isRemovingVoucher }) => {
    const dispatch = useDispatch();
    if (vouchers.length === 0) return null;
    return (
        <div className="voucher-table">
            <table className="voucher-table__registered">
                <caption>{TEXT.TABLE.CAPTION}:</caption>
                <thead>
                    <tr>
                        <th scope="col" id="voucherCode">
                            {TEXT.TABLE.HEADER.CODE}
                        </th>
                    </tr>
                    <tr>
                        <th scope="col" id="remainingBalance">
                            {TEXT.TABLE.HEADER.REMAINING}
                        </th>
                    </tr>
                    <tr>
                        <th scope="col" id="removeCode" className="screen-reader-only">
                            {TEXT.TABLE.HEADER.REMOVE}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {vouchers.map((voucher) => (
                        <tr key={`voucher-row-${voucher.code}`} data-di-mask>
                            <td headers="voucherCode">{anonymizeVoucherCode(voucher.code)}</td>
                            <td headers="remainingBalance">
                                {getFormattedPrice(voucher.balance - voucher.usedBalance)}
                            </td>
                            <td id="removeCode" headers="removeCode">
                                <Button
                                    onClick={() => dispatch(removeVoucherCode(voucher.code))}
                                    variant="text-underline"
                                    loading={isRemovingVoucher}
                                >
                                    {TEXT.TABLE.HEADER.REMOVE}
                                </Button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

const mapStateToProps = (state: RootState) => ({
    isRemovingVoucher: LOADING_SELECTORS.isTypeLoading(state, VOUCHER_REMOVE),
    vouchers: getValidatedVouchers(state),
});

export default connect(mapStateToProps, { removeVoucherCode })(VoucherTable);
